<div>

  <div *ngIf="telefone != null && telefone.length > 8" class="telefone-loja">
    <div class="telefone-loja-icone">
      <i class="fas fa-phone-square-alt"></i>
    </div>
    <div class="telefone-loja-texto">
      <span>SAC {{formatarTelefone(telefone)}}</span>
      <br>
      <span (click)="ajudaWhatsApp()" class="whatsapp"><i class="fab fa-whatsapp"></i> {{formatarTelefone(whatsApp)}}</span>
    </div>
  </div>

  <div class="logo-loja">
    <img src="{{srcLogo}}" title="{{fantasia}}" alt="{{fantasia}}">
  </div>

  <div *ngIf="isFormCPF" class="login-cpf">
    <div class="labelForm">
      <span>Acesso informando seu CPF.</span>
      <br>
      <small>R&aacute;pido. F&aacute;cil. Seguro.</small>
    </div>
    <div class="boxForm">
      <maf-form #formCPF>
        <maf-input-cpf #setFocusCPF [(ngModel)]="CPFConsumidor" (keyup.enter)="buscaCPF()" [valid]="isValidCPF" [disabled]="isLoading" placeHolder="000.000.000-00" ngDefaultControl></maf-input-cpf>
        <div class="btn-default-loja-virtual">
          <maf-button *ngIf="!isBtnNovoCadastro" (click)="buscaCPF()" [loading]="isLoading" [disabled]="!isValidCPF.valid || CPFConsumidor == null || CPFConsumidor.length < 14">&nbsp;CONTINUAR</maf-button>
          <maf-button *ngIf="isBtnNovoCadastro" (click)="novoCadastro()">&nbsp;NOVO CADASTRO</maf-button>
        </div>
      </maf-form>
    </div>
  </div>

  <div *ngIf="isFormConfirmacao" class="chave-confirmacao">
    <div *ngIf="dataConfirmacao?.tipoConfirmacao?.value == '1'" class="labelForm">
      <span>Informe a chave recebida por SMS</span>
      <br>
      <small>Enviada para n&uacute;mero {{dataConfirmacao.envioConfirmacao}}</small>
    </div>
    <div *ngIf="dataConfirmacao?.tipoConfirmacao?.value == '2'" class="labelForm">
      <span>Informe a chave recebida por e-mail</span>
      <br>
      <small>Enviada para o endereço {{dataConfirmacao.envioConfirmacao}}</small>
    </div>
    <div class="boxForm">
      <maf-form #formConfirmacao>
        <maf-input-text #setFocusConfirmacao [(ngModel)]="chaveConfirmacao" [valid]="isValidConfirmacao" [disabled]="isLoading" [maxLength]="4" placeHolder="Digite aqui a chave de 4 digitos" ngDefaultControl></maf-input-text>
        <div class="btn-default-loja-virtual">
          <maf-button (click)="validarChaveConfirmacao()" [loading]="isLoading" [disabled]="!formConfirmacao.valid || chaveConfirmacao == null || chaveConfirmacao.length != 4">&nbsp;CONTINUAR</maf-button>
        </div>
      </maf-form>
    </div>
  </div>

  <div class="opcoes-login">
    <div *ngIf="isFormConfirmacao" class="opcoes-login-esq">
      <a (click)="mudarCPF()">Mudar CPF</a>
    </div>

    <div *ngIf="!isFormConfirmacao" class="opcoes-login-esq novo-cadastro">
      <a (click)="novoCadastro()">Novo Cadastro</a>
    </div>

    <div *ngIf="whatsApp != null && whatsApp.length >= 10" class="opcoes-login-dir">
      <a (click)="ajudaVendedoresLoja()" class="ajuda-whatsapp-lojas">
        <i class="fab fa-whatsapp"></i>
        <span>Fale com nossos vendedores</span>
      </a>
    </div>
  </div>

  <div [ngClass]="{'modal-vendedores-ativo': isModalAjudaVendedores}" class="bg-modal-vendedores">
    <div class="modal-vendedores">
      <div (click)="fecharAjudaVendedoresLoja()" class="fechar-modal-vendedores"><i class="far fa-times"></i></div>
      <div class="conteudo-modal-vendedores" #divLoadComponent></div>
    </div>
  </div>

  <!-- força o load dos icones -->
  <i class="fal fa-user" style="font-size: 1px; line-height: 1px; color: #fff;"></i>
  <div class="clear"></div>
</div>
